import { useNavigate } from 'react-router-dom'
import postMessageToRN, {
  TAP_KNOW_ABOUT_PROGRAM,
} from '../../../utils/helpers/ReactNativeEvents'
import { checkUserPlanFree } from '../../../utils/helpers/common'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../store/slices/index'
import {
  supportProgramStatus,
  supportProgramTypes,
} from '../../../constants/support-programs'

const useLiverForeverCarePlan = () => {
  const navigate = useNavigate()
  const supportProgram = supportProgramTypes['liver-forever-program']
  const { patientDetails } = useSelector((state) => state.auth)
  const { ftuDocumentsWithoutVisit: documents } = useSelector(
    (state) => state.records,
  )
  const { addressList } = useSelector((state) => state.location)
  const dispatch = useDispatch()
  // const supportProgram = supportProgramTypes[params?.support_program_type]
  const isPaidUser = !checkUserPlanFree(patientDetails?.data?.patient_plans)

  useEffect(() => {
    if (isPaidUser) {
      navigate('/care-plans/liver-forever-program/plan-assigned')
    } else {
      supportProgram?.steps?.map((step) => {
        if (step.id === 'address') {
          getAddressList()
        } else if (step.id === 'documents') {
          fetchDocuments(step?.upload_report_type)
        }
      })
    }
  }, [supportProgram, isPaidUser])

  useEffect(() => {
    console.log('documents', documents?.data)
    // const documentStep = supportProgram?.steps?.find(
    //   (step) => step?.id === 'documents',
    // )
    // const addressStep = supportProgram?.steps?.find(
    //   (step) => step?.id === 'address',
    // )

    // if (documentStep) {
    //   const isAllDocumentsUploaded =
    //     documents?.data?.data?.length === documentStep?.document_types?.length

    //   if (isAllDocumentsUploaded) {

    //     if (addressStep) {
    //       // If address step exists, check if address is added
    //       if (addressList?.data?.length > 0) {
    //         navigate('/care-plans/liver-forever-program/plan-assigned')
    //       }
    //     } else {
    //       // If no address step, navigate directly
    //       navigate('/care-plans/liver-forever-program/plan-assigned')
    //     }
    //   }
    // }

    if (!isPaidUser) {
      supportProgram?.steps?.forEach((step) => {
        if (step.id === 'documents') {
          const isAllDocumentsUploaded =
            documents?.data?.data?.length === step?.document_types?.length

          if (isAllDocumentsUploaded) {
            const allVerified = documents?.data?.data?.every(
              (document) =>
                document?.record_meta_info?.report_status ===
                supportProgramStatus.DOCUMENT_REVIEW_STATUS.APPROVED,
            )
            const somePending = documents?.data?.data?.some(
              (document) =>
                document?.record_meta_info?.report_status ===
                supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW,
            )
            const hasRejected = documents?.data?.data?.some(
              (document) =>
                document?.record_meta_info?.report_status ===
                supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED,
            )

            let status = 'ALL_DOC_APPROVED'
            if (hasRejected) {
              status = 'SOME_ISSUE_WITH_ONE_OF_DOC'
            } else if (somePending) {
              status = 'SOME_DOC_PENDING'
            }

            // if (allVerified) {
            //   navigate('/care-plans/liver-forever-program/plan-assigned')
            // } else {
            navigate(
              `/care-plans/liver-forever-program/plan-status?status=${status}`,
            )
            // }
          }
        }
      })
    }
  }, [documents, supportProgram, addressList, navigate])

  const fetchDocuments = (report_type) => {
    const payload = {
      patient_id: patientDetails?.data?.patient_id,
      report_type,
    }
    new Promise((resolve, reject) => {
      dispatch(
        actions.fetchLiverFTUDocumentsWithoutVisitRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  const getAddressList = () => {
    const payload = {}
    new Promise((resolve, reject) => {
      dispatch(
        actions.getAddressListRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  const handleKnowMoreProgramClick = () => {
    postMessageToRN(TAP_KNOW_ABOUT_PROGRAM)
  }

  const handleUploadDocumentsClick = () => {
    // navigate(
    //   `/care-plans/upload-documents?support_program_type=${supportProgram.id}`,
    // )
    navigate('/care-plans/liver-forever-program/journey')
  }

  return {
    supportProgram,
    handleKnowMoreProgramClick,
    handleUploadDocumentsClick,
  }
}

export default useLiverForeverCarePlan
